var map = {
	"./de": [
		"e81c",
		"lang-de"
	],
	"./de.ts": [
		"e81c",
		"lang-de"
	],
	"./en": [
		"a84e",
		"lang-en"
	],
	"./en.ts": [
		"a84e",
		"lang-en"
	],
	"./fr": [
		"3b6b",
		"lang-fr"
	],
	"./fr.ts": [
		"3b6b",
		"lang-fr"
	],
	"./nl": [
		"ef42"
	],
	"./nl.ts": [
		"ef42"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "326a";
module.exports = webpackAsyncContext;